import { CATEGORY_BY_ID } from '../categories';
import type { Registration } from '../registry';

const n = CATEGORY_BY_ID.lan.colour;

export const lanRegistration: Registration = {
  definitions: [
    {
      type: 'esp32_eth_begin',
      message0: 'Ethernet start (W5500) CS pin %1 (DHCP, put in "when board starts")',
      args0: [{ type: 'field_number', name: 'CS', value: 5, min: 0, max: 48, precision: 1 }],
      previousStatement: null,
      nextStatement: null,
      colour: n,
      tooltip: 'Start a W5500 Ethernet module over SPI and get an IP address via DHCP.',
    },
    {
      type: 'esp32_eth_begin_static',
      message0: 'Ethernet start (W5500) CS pin %1 IP %2 gateway %3 subnet %4 (put in "when board starts")',
      args0: [
        { type: 'field_number', name: 'CS', value: 5, min: 0, max: 48, precision: 1 },
        { type: 'field_input', name: 'IP', text: '192.168.1.50' },
        { type: 'field_input', name: 'GATEWAY', text: '192.168.1.1' },
        { type: 'field_input', name: 'SUBNET', text: '255.255.255.0' },
      ],
      previousStatement: null,
      nextStatement: null,
      colour: n,
      tooltip: 'Start a W5500 Ethernet module over SPI with a fixed IP configuration.',
    },
    {
      type: 'esp32_eth_connected',
      message0: 'Ethernet link up?',
      output: 'Boolean',
      colour: n,
      tooltip: 'True while the Ethernet cable is plugged in and the link is on.',
    },
    {
      type: 'esp32_eth_local_ip',
      message0: 'Ethernet local IP',
      output: 'String',
      colour: n,
      tooltip: 'The assigned IP address as text.',
    },
    {
      type: 'esp32_eth_maintain',
      message0: 'Ethernet renew lease (maintain)',
      previousStatement: null,
      nextStatement: null,
      colour: n,
      tooltip: 'Renew the DHCP lease (call occasionally in the loop for long-running DHCP setups).',
    },
  ],
  metas: [
    {
      type: 'esp32_eth_begin',
      category: 'lan',
      label: 'Ethernet start (DHCP)',
      description: 'Start a W5500 LAN module over SPI (CS pin configurable) and request an IP via DHCP.',
      fields: { CS: { kind: 'number' } },
    },
    {
      type: 'esp32_eth_begin_static',
      category: 'lan',
      label: 'Ethernet start (fixed IP)',
      description: 'Start a W5500 LAN module over SPI with a fixed IP, gateway and subnet.',
      fields: { CS: { kind: 'number' }, IP: { kind: 'text' }, GATEWAY: { kind: 'text' }, SUBNET: { kind: 'text' } },
    },
    {
      type: 'esp32_eth_connected',
      category: 'lan',
      label: 'Ethernet link up',
      description: 'Value: true when the Ethernet cable link is up.',
      fields: {},
    },
    {
      type: 'esp32_eth_local_ip',
      category: 'lan',
      label: 'Ethernet local IP',
      description: 'Value: the Ethernet IP address as text.',
      fields: {},
    },
    {
      type: 'esp32_eth_maintain',
      category: 'lan',
      label: 'Ethernet renew lease',
      description: 'Renew the DHCP lease (Ethernet.maintain).',
      fields: {},
    },
  ],
};
